// Group GROUP 11. Collocations and Phrasal Verbs
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group11Data = {
  "id": "group_11",
  "title": {
    "tc": "固定搭配與片語動詞",
    "sc": "固定搭配与短语动词",
    "en": "Collocations and Phrasal Verbs"
  },
  "subtitle": {
    "tc": "Collocations and Phrasal Verbs",
    "sc": "Collocations and Phrasal Verbs",
    "en": "Collocations and Phrasal Verbs"
  },
  "icon": "🔗",
  "difficulty": "intermediate",
  "color": "from-indigo-500 to-indigo-600",
  "topics": [
    {
      "id": "phrasal_verbs",
      "title": {
        "tc": "片語動詞",
        "sc": "短语动词",
        "en": "Phrasal Verbs"
      },
      "description": {
        "tc": "學習片語動詞的用法",
        "sc": "学习短语动词的用法",
        "en": "Learn the usage of phrasal verbs"
      },
      "icon": "🔗",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "phrasal_1",
          "sentence": "Please turn off the lights.",
          "analysis": "(You) (S) turn off (V-phr) the lights (O).",
          "translation": {
            "tc": "請關燈。",
            "sc": "请关灯。",
            "en": "Please turn off the lights."
          }
        },
        {
          "id": "phrasal_2",
          "sentence": "He ran into an old friend.",
          "analysis": "He (S) ran into (V-phr) an old friend (O).",
          "translation": {
            "tc": "他遇到了一個老朋友。",
            "sc": "他遇到了一个老朋友。",
            "en": "He ran into an old friend."
          }
        },
        {
          "id": "phrasal_3",
          "sentence": "We look forward to your reply.",
          "analysis": "We (S) look forward to (V-phr) your reply (O).",
          "translation": {
            "tc": "我們期待您的回覆。",
            "sc": "我们期待您的回复。",
            "en": "We look forward to your reply."
          }
        },
        {
          "id": "phrasal_4",
          "sentence": "She picked up the package.",
          "analysis": "She (S) picked up (V-phr) the package (O).",
          "translation": {
            "tc": "她撿起了包裹。",
            "sc": "她捡起了包裹。",
            "en": "She picked up the package."
          }
        },
        {
          "id": "phrasal_5",
          "sentence": "Don't give up yet.",
          "analysis": "(You) (S) do not give up (V-phr) yet (M).",
          "translation": {
            "tc": "還不要放棄。",
            "sc": "还不要放弃。",
            "en": "Don't give up yet."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：動詞+副詞/介詞形成固定意義；分離/不可分離需記憶。",
        "sc": "要点：动词+副词/介词形成固定意义；分离/不可分离需记忆。",
        "en": "Key points: verb + adverb/preposition form fixed meanings; separable/inseparable need memorization."
      }
    }
  ]
};
